import React, {useState, useEffect } from 'react';
import { Input } from 'antd';

interface SearchBarProps {
  searchText: string
  onSearch: (value: string) => void;
  placeholder?: string;
}

const { Search } = Input;

const SearchBar: React.FC<SearchBarProps> = ({ onSearch, searchText, placeholder = "Search..."}) => {
  const [textVal, setTextVal] = useState<string>(searchText);

  useEffect(()=>{
    setTextVal(searchText);
  },[searchText])

  const handleChange = (value: string) => {
    setTextVal(value);
    if(value === ""){
      onSearch(value);
    }
  };

  // Handle input changes
  const handleSearch = (val:string, e:any, info?:{ source? : 'clear' | 'input'}) => {
    // Clear is handled in above empty string.(To prevent two calls)
    if(info?.source === 'clear'){
        return
    }
    onSearch(val);
  };


  return (
    <Search
      placeholder={placeholder}
      value={textVal}
      onChange={(e) => handleChange(e.target.value)}
      onSearch={handleSearch}
      enterButton
      allowClear
      style={{ width: 300 }}
    />
  );
};

export default SearchBar;
